import React from 'react';
import logoBp from '../../../estilo/comum/img/logo_siqeira.webp';
import iconSiqueiratur from '../../../estilo/comum/img/icon/siqueiratur.png';
import ConteudoQuemSomosAD from '../../../componentes/quem-somos/siqueiratur/ConteudoQuemSomosAD';
import dadosSiteComum from './dadosSiteComum';
import cardPrecoPromocao from '../../../estilo/comum/img/carouselCards/11.webp';
import cardContrateVexado from '../../../estilo/comum/img/carouselCards/19.webp';
import cardModalPromocao from '../../../estilo/comum/img/carouselCards/cupomDescontoBrasilpassagens.webp';
import cardQueroAgencia from '../../../estilo/comum/img/carouselCards/20.webp';

const logoBrasilCabecalho = <img className="logo-site brasilp" src={logoBp} alt='Logo Brasil Passagens'/>;
const logoBrasilRodape = <img className="brasilp" src={logoBp} alt="Logo Brasil Passagens" style={{width: '45%'}}/>;

export const dadosSiqueiraturConfig = {
    ...dadosSiteComum,
    id: 'siqueiratur',
    pastaEstilo: 'siqueiratur',
    nome: 'Siqueira Tur',
    nomePrefixo: 'o Siqueira Tur',
    razaoSocial: 'VEXADO PROMOTORA DE VENDAS E INTERMEDIAÇÕES DE NEGÓCIOS EIRELI',
    cnpj: '32.843.031/0001-09',
    endereco:'Q SCS Quadra 01, Bloco M, número 30, Sala 508, Asa Sul/DF, CEP: 70.305-900',
    telefone: '(97) 8433-4498',    
    wtpp: '(92) 98438-0079',    
    instagram: 'https://www.instagram.com/siqueiraturhumaita',
    tiktok: 'https://www.tiktok.com/@vexadoo',
    facebook: 'https://www.facebook.com/siqueiratur.net/',
    youtube: 'youtube.com',
    email: 'siqueiratur1@hotmail.com',
    emailSuporte: 'siqueiratur1@hotmail.com',
    lkemailSuporte: 'mailto:siqueiratur1@hotmail.com',
    lktelefone: 'tel:559284380079',
    twitter: '@siqueiraturhumaita',
    lkemail: 'mailto:siqueira.tur@hotmail.com',
    lkwhats: 'https://api.whatsapp.com/send?phone=5592984380079&text=Olá. Preciso de atendimento.',
    logo: logoBp,
    logoCabecacho: logoBrasilCabecalho,
    logoRodape: logoBrasilRodape,
    OgImage: 'https://imagens-open-graph-sites-agencias.s3.amazonaws.com/brasil-passagens/Brasil+passagens.webp',
    description: 'Compre passagens de ônibus sem sair de casa. São diversas opções de horários e viações para você escolher.',
    icone: iconSiqueiratur,
    quemSomos: ConteudoQuemSomosAD,
    videoInicio: 'https://imagens-vexado-live.s3.sa-east-1.amazonaws.com/video-backbp2.mp4',
    idsTagManager: ['GTM-PHGZ336'],
    bannerModalPromocao: 'https://imagens-banner-promocao-sites.s3.amazonaws.com/cupom+de+descontoBrasilpassagens.webp',
    cardPrecoPromocao: cardPrecoPromocao,
    cardContrateVexado: cardContrateVexado,
    cardModalPromocao: cardModalPromocao,
    cardQueroAgencia: cardQueroAgencia,
    banner: 'https://imagens-vexado-live.s3.sa-east-1.amazonaws.com/1.webp',
    bannerMobile: 'https://imagens-vexado-live.s3.sa-east-1.amazonaws.com/1.mobile.webp',
    urlBase: 'https://brasilpassagens.com.br'
};